module.exports = __webpack_public_path__ + "static/Andrea-Giovannini-582569bfab0cf563c64300fb73252c72.png";